import {
	Graphics, Sprite, Text, TextMetrics, TextStyle,
} from 'pixi.js';
//import { Easing, Tween, autoPlay } from '../GameEngine/es6-tween.js'

const DEFAULT_COLOR = 0xFFFFFF;// or 0x479ACE or 0xC03500
export class ChatBubble extends Sprite {
	constructor(text, color = DEFAULT_COLOR, stemDirection = 'down', ...arg) {
		super(...arg);
		this.text = text || '';
		this.color = color;
		this.stemDirection = stemDirection;
		this.style = new TextStyle({
			fontFamily: 'Arial',
			fontSize: 80,
			fill: '#000000',
			wordWrap: true,
			wordWrapWidth: 1200,
			align: 'left',
		});

		//chat box
		this.textBackground = new Graphics();
		this.textBackground.beginFill(this.color);
		//textBackground.lineStyle(4, 0xFFFF00, 1);
		this.textBackground.lineStyle(0, 0xFFFF00, 1);
		// scoreBox.drawRect(0,115, 100, 25);
		//this.textBackground.drawRect(0, 0, 400, 20 + 5 + 5);
		this.textBackground.drawRoundedRect(0, 0, 400, 40 + 5 + 5, 10);
		//scoreBox.alpha = 0.5;
		this.addChild(this.textBackground);

		this.chatStemDown = new Graphics();
		this.chatStemDown.beginFill(this.color);
		this.chatStemDown.lineStyle(0, 0xFFFF00, 1);
		this.chatStemDown.moveTo(10, 50);
		this.chatStemDown.lineTo(20, 50);
		this.chatStemDown.lineTo(10, 65);
		this.chatStemDown.lineTo(10, 50);
		this.chatStemDown.endFill();
		this.addChild(this.chatStemDown);

		this.chatStemUp = new Graphics();
		this.chatStemUp.beginFill(this.color);
		this.chatStemUp.lineStyle(0, 0xFFFF00, 1);
		this.chatStemUp.moveTo(10, 0);
		this.chatStemUp.lineTo(20, 0);
		this.chatStemUp.lineTo(10, -15);
		this.chatStemUp.lineTo(10, 0);
		this.chatStemUp.endFill();
		this.addChild(this.chatStemUp);
		this.chatStemUp.visible = false;

		this.setStemDirection();

		//create text 
		//hack: scale text to 1/2 the size and incress the font 2x to force better res when streching to a larger screen.  
		//hack: pixelDensity solves this partly, but when the container is scaled it does not know such as desktop with pixelDensity of 1.
		this.textMessage = new Text(this.text, this.style);
		this.textMessage.x = 5;
		this.textMessage.y = 5;
		this.textMessage.scale.set(0.5);
		this.textMessage.anchor.set(0, 0);
		//this.textMessage.resolution = 2;//does not seem to do anything
		this.addChild(this.textMessage);

		if (this.text === '') {
			this.hide();
		}
		//this.hide();

		// this.show('Test Test Test Test Test Test');

		// this.tweenGroup = new TWEEN.Group();

		// this.tween = new TWEEN.Tween(this, this.tweenGroup);
		// this.tween.to({ width: 1 }, 500);
		// this.tween.easing(TWEEN.Easing.Exponential.Out);
		// this.tween.onStart(this.onStart.bind(this));
		// //this.tween.onComplete(this.onComplete.bind(this));
		// // this.tween.onStop(this.onStop.bind(this));

		// this.tween2 = new TWEEN.Tween(this, this.tweenGroup);
		// this.tween2.delay(6000);
		// this.tween2.to({ alpha: 0 }, 300);
		// this.tween2.easing(TWEEN.Easing.Exponential.Out);
		// this.tween2.onComplete(this.onComplete.bind(this));
		// this.tween.chain(this.tween2);
		// //.start();
	}

	update() {
		let isDirty = false;

		const isPlaying = this.tween.isPlaying() || this.tween2.isPlaying();
		if (isPlaying) {
			this.tweenGroup.update();
			isDirty = true;
		}

		return isDirty;
	}

	onStart() {
		this.visible = true;
	}

	onComplete() {
		this.visible = false;
	}

	onStop() {
		this.visible = false;
	}

	show(text) {
		if (text) {
			this.text = text;
			this.textMessage.text = text;
			const textMetrics = TextMetrics.measureText(text, this.style);
			const width = textMetrics.width;
			this.textBackground.width = (width / 2) + 5 + 5;

			this.visible = true;

			// //reset pos - note:should wok onStart but can get it to work
			// this.width = 0;
			// this.alpha = 1;
			// this.tween?.start?.();
			//this.visible = true;
			this.setStemDirection();
		} else {
			this.visible = false;
		}
	}

	hide() {
		this.visible = false;
	}

	setStemDirection() {
		if (this.stemDirection === 'down') {
			this.chatStemDown.visible = true;
			this.chatStemUp.visible = false;
		} else {
			this.chatStemDown.visible = false;
			this.chatStemUp.visible = true;
		}
	}
}
